<!-- 由 Dioa 创建于 2022-06-27 星期一 -->
<template>
  <div
    class="image-pop"
    v-if="showImage"
    @touchmove.stop.prevent
    @click.stop="showImage = false"
  >
    <img :src="imageUrl" class="qrcode-image" alt="" @click.stop.prevent />
    <!-- <div class="download-wrapper">
      <img
        class="download-icon"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-save"
        alt=""
      />
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'image-pop',

  components: {},

  props: {
    visible: {
      required: true,
      type: Boolean,
      default: () => {
        return false
      }
    },
    imageUrl: {
      required: true,
      type: String,
      default: () => {
        return ''
      }
    }
  },

  data() {
    return {
      showImage: false
    }
  },

  computed: {},

  watch: {
    visible(val, oldVal) {
      if (val == oldVal) return
      this.showImage = val
    },
    showImage(val, oldVal) {
      if (val == oldVal) return
      this.$emit('update:visible', val)
    }
  },

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.image-pop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(#000, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 999999;
  .qrcode-image {
    width: vw(240);
    height: auto;
    object-fit: cover;
    background-color: #fff;
    border-radius: vw(12);
  }
  .download-wrapper {
    margin-top: vw(24);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .download-icon {
      width: vw(72);
    }
    .download-text {
      font-size: vw(18);
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
